import {
  AppBar,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Collapse,
  colors,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Pagination,
  Skeleton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Header from "components/Header";
import BG from "assets/images/BG.png";
import Contact from "components/Contact";
import {
  ArrowBackIos,
  ArrowBackIosNew,
  ArrowForwardIos,
  ChevronLeft,
  ChevronRight,
  DirectionsCar,
  ExpandLess,
  ExpandMore,
  MapsHomeWork,
  NorthEast,
  Search,
  ShoppingBag,
  Sort,
  Whatshot,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import CustomPagination from "components/TableExplanded/Pagination";
import ModalProduct from "components/Modal/MarketPlace/ModalProduct";
import { GradientCircularProgress } from "components/Loading";
import api from "_api";
import { useNavigate, useSearchParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  cardProducts: {
    borderRadius: "25px",
    width: "100%",
    height: "100%",
    border: "1px solid #e0e0e0",
    boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.25)",
  },
}));

const defaultArrowStyle = {
  color: "white", // สีของไอคอนลูกศร
  backgroundColor: "rgba(0, 0, 0, 0.5)", // สีพื้นหลังของไอคอน
  height: "40px", // ความสูงของไอคอน
  fontSize: "1.5rem", // ขนาดของไอคอน
  position: "absolute",
  zIndex: 10,
  cursor: "pointer",
  "&:hover": {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

const CustomNextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <ArrowForwardIos
      className={className}
      onClick={onClick}
      sx={{
        ...defaultArrowStyle,
        right: "-10px", // ตำแหน่งแนวนอน
      }}
    />
  );
};

const CustomPrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <ArrowBackIosNew
      className={className}
      onClick={onClick}
      sx={{
        ...defaultArrowStyle,
        left: "-10px", // ตำแหน่งแนวนอน
      }}
    />
  );
};

const PriceFormatter = ({ price }) => {
  return (
    <Typography
      sx={{
        fontSize: "18px",
        fontWeight: "medium",
        color: "#00bb9f",
      }}
    >
      {price >= 1000000
        ? `${(price / 1000000).toFixed(price % 1000000 > 0 ? 1 : 0)} ลบ`
        : `${price.toLocaleString()} บ`}
    </Typography>
  );
};

const DEFAULTMENUS = [
  {
    title: "สินค้า",
    segment: "product",
    icon: <ShoppingBag />,
    children: [
      { label: "เครื่องประดับ", id: 1 },
      { label: "อิเล็กทรอนิกส์", id: 2 },
      { label: "ทองคำ", id: 3 },
      { label: "พระเครื่อง", id: 4 },
      { label: "แบรนด์เนม", id: 5 },
      { label: "นาฬิกา", id: 6 },
    ],
  },
  {
    title: "รถ",
    segment: "car",
    icon: <DirectionsCar />,
    children: [
      {
        label: "รถยนต์",
        id: "car",
      },
      {
        label: "รถมอเตอร์ไซค์",
        id: "motorcycle",
      },
      {
        label: "รถจักรยาน",
        id: "bicycle",
      },
      {
        label: "รถตู้",
        id: "van",
      },
      {
        label: "รถซุปเปอร์คาร์",
        id: "supercar",
      },
    ],
  },
  {
    title: "อสังหาริมทรัพย์",
    segment: "house",
    icon: <MapsHomeWork />,
    children: [
      {
        label: "ที่ดิน",
        id: "land",
      },
      {
        label: "คอนโด",
        id: "condo",
      },
      {
        label: "บ้านเดี่ยว",
        id: "house",
      },
      {
        label: "ตึกแถวอาคารพาณิชย์",
        id: "shophouse",
      },
      {
        label: "อาคารสำนักงาน",
        id: "office",
      },
      {
        label: "โฮมออฟฟิศ",
        id: "homeoffice",
      },
      {
        label: "โรงงาน/โกดัง/คลังสินค้า",
        id: "factory",
      },
      {
        label: "ร้านค้า/ร้านอาหาร",
        id: "shop",
      },
      {
        label: "โชว์รูม/สำนักงานขาย",
        id: "showroom",
      },
      {
        label: "กิจการ/โรงแรม/หอพัก",
        id: "hotel",
      },
    ],
  },
];

function MarketPlace() {
  const classes = useStyles();
  const [openSubMenu, setOpenSubMenu] = useState([]);
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [lastestProducts, setLastestProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const product_type = searchParams.get("product");

  const [filter, setFilter] = useState({
    search: "",
    category: [],
    type: null,
    sortBy: "",
  });

  const [paginate, setPaginate] = useState({
    page: 0,
    limit: 10,
    totalItems: 0,
    totalPages: 0,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [activeSlide, setActiveSlide] = useState(0);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (product_type) {
      if (product_type === "popular" || product_type === "latest") {
        fetchProductsMarketPlace(product_type);
      } else {
        fetchProductsMarketPlace();
      }
    } else {
      fetchProductsMarketPlace("popular");
      fetchProductsMarketPlace("latest");
      fetchProductsMarketPlace();
    }
  }, [product_type, paginate.page, paginate.limit, filter]);

  const fetchProductsMarketPlace = async (type) => {
    const filters = {
      ...filter,
      type: type ?? null,
      page: !product_type && type ? 1 : paginate.page + 1,
      limit: paginate.limit,
    };

    await api.marketplace
      .getProductsMarketPlace(filters)
      .then((res) => {
        if (res.isStatus) {
          if (type === "popular") {
            if (product_type) {
              setProducts(res.data?.data);
              setPaginate({
                ...paginate,
                totalItems: res.data?.totalItems,
                totalPages: res.data?.totalPages,
              });
            } else {
              setRecommendedProducts(res.data?.data);
            }
          } else if (type === "latest") {
            if (product_type) {
              setProducts(res.data?.data);
              setPaginate({
                ...paginate,
                totalItems: res.data?.totalItems,
                totalPages: res.data?.totalPages,
              });
            } else {
              setLastestProducts(res.data?.data);
            }
          } else {
            setProducts(res.data?.data);
            setPaginate({
              page: res.data?.currentPage - 1,
              limit: res.data?.limit,
              totalItems: res.data?.totalItems,
              totalPages: res.data?.totalPages,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      })
      .finally(() => {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      });
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <GradientCircularProgress />
      </Box>
    );
  }

  const settings = {
    infinite: true, // เลื่อนแบบไม่สิ้นสุด
    speed: 500, // ความเร็วในการเปลี่ยนสไลด์
    slidesToShow:
      recommendedProducts.length < 5 ? recommendedProducts.length : 5, // จำนวนสไลด์ที่แสดงในแต่ละครั้ง
    slidesToScroll:
      recommendedProducts.length < 5 ? recommendedProducts.length : 5, // จำนวนสไลด์ที่เลื่อนในแต่ละครั้ง
    autoplay: recommendedProducts.length > 5 ? true : false, // สไลด์อัตโนมัติ
    autoplaySpeed: 2000, // ความเร็วในการสไลด์อัตโนมัติ
    dots: true, // แสดงจุดเลื่อน
    arrows: true, // แสดงปุ่มกดเพื่อเปลี่ยนสไลด์
    nextArrow: <CustomNextArrow />, // ปุ่มกดเพื่อเปลี่ยนสไลด์
    prevArrow: <CustomPrevArrow />, // ปุ่มกดเพื่อเปลี่ยนสไลด์
    responsive: [
      {
        breakpoint: 1500, // ความกว้างหน้าจอ <= 1600px
        settings: {
          slidesToShow: 4, // แสดง 4 slides
          slidesToScroll: 4,
          afterChange: (current) => {
            setActiveSlide(Math.floor(current / 4));
          },
          beforeChange: (current, next) => {
            setActiveSlide(Math.floor(next / 4));
          },
        },
      },
      {
        breakpoint: 1200, // ความกว้างหน้าจอ <= 1200px
        settings: {
          slidesToShow: 3, // แสดง 3 slides
          slidesToScroll: 3,
          afterChange: (current) => {
            setActiveSlide(Math.floor(current / 3));
          },
          beforeChange: (current, next) => {
            setActiveSlide(Math.floor(next / 3));
          },
        },
      },
      {
        breakpoint: 992, // ความกว้างหน้าจอ <= 992px
        settings: {
          slidesToShow: 2, // แสดง 2 slides
          slidesToScroll: 2,
          afterChange: (current) => {
            setActiveSlide(Math.floor(current / 2));
          },
          beforeChange: (current, next) => {
            setActiveSlide(Math.floor(next / 2));
          },
        },
      },
      {
        breakpoint: 768, // ความกว้างหน้าจอ <= 768px
        settings: {
          slidesToShow: 1, // แสดง 1 slide
          slidesToScroll: 1,
          afterChange: (current) => {
            setActiveSlide(current);
          },
          beforeChange: (current, next) => {
            setActiveSlide(next);
          },
        },
      },
    ],
    afterChange: (current) => {
      setActiveSlide(Math.floor(current / 5));
    },
    beforeChange: (current, next) => {
      setActiveSlide(Math.floor(next / 5));
    },
    customPaging: (i) => (
      <Box
        sx={{
          width: "30px",
          height: "10px",
          backgroundColor: activeSlide === i ? "#00bb9f" : "rgba(0, 0, 0, 0.2)",
          borderRadius: "16px",
          transition: "all 0.3s ease",
        }}
      />
    ),
    appendDots: (dots) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          gap: 1,
        }}
      >
        {dots}
      </Box>
    ),
  };

  const handleSubMenuClick = (index) => {
    setOpenSubMenu((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const handleModal = () => {
    setOpenModal(!openModal);
  };

  const handleAllProduct = (type) => {
    setPaginate({ ...paginate, page: 0, limit: 10 });
    navigate(`/marketplace?product=${type}`);
  };

  const handlePageChange = (event, newValue) => {
    setPaginate({ ...paginate, page: newValue });
  };

  const handleRowsPerPageChange = (e) => {
    setPaginate({
      ...paginate,
      limit: parseInt(e.target.value, 10),
      page: 0,
    });
  };

  const renderProductCard = (product, index) => {
    const { Product } = product;
    return (
      <>
        <Card className={classes.cardProducts}>
          <CardMedia
            component="img"
            image={Product.Pictures[0]?.pic}
            alt={Product.product_name}
            height={250}
            sx={{
              borderRadius: "25px",
              padding: "8px",
            }}
          />
          <CardContent
            sx={{
              width: "100%",
              padding: 1,
              height: "auto",
              "&:last-child": { paddingBottom: 1 },
            }}
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "medium",
                color: "#212529",
              }}
              noWrap
            >
              {Product.product_name}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "Regular",
                color: "#6c6c6c",
              }}
            >
              {product.type}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <PriceFormatter price={Product.price} />
              <Button
                className="button-two-tone"
                variant="contained"
                sx={{
                  width: "auto",
                  borderRadius: "12px",
                }}
                onClick={() => {
                  setSelectedProduct(product);
                  handleModal();
                }}
              >
                เพิ่มเติม
              </Button>
            </Box>
          </CardContent>
        </Card>
      </>
    );
  };

  return (
    <>
      <Header />
      {/* title */}
      <Box
        sx={{
          position: "relative",
          backgroundImage: `url(${BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "300px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: "76px",
        }}
      >
        <Typography variant="h3">MarketPlace</Typography>
        <Typography variant="h5">สินค้าที่อยู่ในระบบ</Typography>
      </Box>
      {/* search bar */}
      <Box
        sx={{
          position: "sticky",
          top: "76px", // To ensure it doesn't overlap with the header
          backgroundColor: "#fff",
          zIndex: 1200, // Ensures search bar stays below the header
        }}
      >
        <AppBar
          sx={{
            backgroundColor: "#bfeee7",
            boxShadow: "none",
            height: "86px",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            zIndex: 1200,
          }}
          position="sticky"
        >
          <TextField
            hiddenLabel
            placeholder="ค้นหา"
            variant="outlined"
            sx={{
              width: "1000px",
              backgroundColor: "white",
              borderRadius: "12px",
              border: "0px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "54px",
                border: "0px",
              },
              "& fieldset": {
                border: "none", // default Textfield
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={(e) => setFilter({ ...filter, search: e.target.value })}
          />
          <Button
            id="sort_by_price"
            variant="contained"
            sx={{
              backgroundColor: "white",
              color: "#00bb9f",
              borderRadius: "12px",
              width: "auto",
              height: "50px",
              ml: 2,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "white",
                boxShadow: "none",
              },
            }}
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <Sort />
          </Button>
          <Menu
            id="sort_by_price"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            sx={{
              "& .MuiMenu-paper": {
                borderRadius: "12px",
                "& .MuiMenuItem-root": {
                  height: "30px",
                },
              },
            }}
          >
            <MenuItem
              onClick={() => {
                setFilter({ ...filter, sortBy: "asc" });
                handleClose();
              }}
            >
              ราคา สูง - ต่ำ
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem
              onClick={() => {
                setFilter({ ...filter, sortBy: "desc" });
                handleClose();
              }}
            >
              ราคา ต่ำ - สูง
            </MenuItem>
          </Menu>
        </AppBar>
      </Box>
      <Box className="bg-white">
        <Grid container spacing={2}>
          {/* Sidebar */}
          <Grid
            size={4}
            sx={{
              width: "20%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                position: "sticky",
                top: "162px",
                mt: 2,
              }}
            >
              <List
                sx={{ width: "100%", maxWidth: "100%", ml: 2 }}
                component="nav"
              >
                {DEFAULTMENUS.map((item, index) => (
                  <>
                    <ListItem
                      key={index}
                      onClick={() => handleSubMenuClick(index)}
                    >
                      <ListItemButton
                        sx={{
                          borderLeft: openSubMenu[index]
                            ? "4px solid #00bb9f"
                            : "",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            color: "#00bb9f",
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            fontSize: "16px",
                            fontWeight: "SemiBold",
                            fontFamily: "prompt",
                            color: openSubMenu[index] ? "#00bb9f" : "#737373",
                          }}
                          primary={item.title}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: colors.grey[100],
                            borderRadius: "50%",
                            color: "#737373",
                          }}
                        >
                          {openSubMenu[index] ? <ExpandLess /> : <ExpandMore />}
                        </Box>
                      </ListItemButton>
                    </ListItem>
                    <Collapse
                      in={openSubMenu[index]}
                      timeout="auto"
                      unmountOnExit
                      sx={{
                        mx: 4,
                      }}
                    >
                      <List
                        component="div"
                        disablePadding
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "12px",
                          "& .MuiListItem-root": {
                            "&:hover": {
                              "& .MuiCheckbox-root, & .MuiTypography-root": {
                                color: "#00bb9f",
                              },
                            },
                          },
                        }}
                      >
                        {item.children.map((child, childIndex) => (
                          <ListItem key={childIndex} disablePadding>
                            <ListItemButton
                              onClick={() => {
                                if (filter.category.includes(child.id)) {
                                  setFilter({
                                    ...filter,
                                    category: filter.category.filter(
                                      (type) => type !== child.id
                                    ),
                                  });
                                } else {
                                  setFilter({
                                    ...filter,
                                    category: [...filter.category, child.id],
                                  });
                                }
                              }}
                            >
                              <ListItemIcon>
                                <Checkbox
                                  id={index + "-checkbox-" + childIndex}
                                  sx={{
                                    "&.Mui-checked": {
                                      color: "#00bb9f",
                                    },
                                  }}
                                  checked={filter.category.includes(child.id)}
                                />
                              </ListItemIcon>
                              <ListItemText
                                sx={{
                                  fontSize: "14px",
                                }}
                                primary={child.label}
                              />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </>
                ))}
              </List>
            </Box>
          </Grid>
          {/* Content */}
          <Grid
            size={8}
            sx={{
              width: "80%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {product_type !== null ? (
              <Box
                sx={{
                  padding: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "100%",
                    mt: 2,
                    gap: 2,
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontSize: "32px" }}>
                      {product_type === "popular"
                        ? "สินค้ายอดฮิต"
                        : product_type === "latest"
                        ? "สินค้าล่าสุด"
                        : "สินค้าทั้งหมด"}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setPaginate({ ...paginate, page: 0, limit: 10 });
                        navigate({
                          pathname: "/marketplace",
                        });
                      }}
                    >
                      <ChevronLeft
                        sx={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                      <Typography
                        sx={{
                          fontWeight: "Regular",
                          fontSize: "20px",
                        }}
                      >
                        ย้อนกลับ
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      padding: 1,
                      width: "100%",
                    }}
                  >
                    <Grid container spacing={2}>
                      {products.slice(0, 15).map((product, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                          {renderProductCard(product, index)}
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                  <CustomPagination
                    count={paginate.totalItems}
                    page={paginate.page}
                    rowsPerPage={paginate.limit}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  padding: 2,
                }}
              >
                {/* Recommended or Hot Products */}
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    background:
                      "linear-gradient(to right, rgba(76, 184, 186, 0.1), rgba(123, 216, 103, 0.1))",
                    width: "100%",
                    gap: 2,
                    borderRadius: "8px",
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontSize: "32px" }}>
                      สินค้ายอดฮิต
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleAllProduct("popular")}
                    >
                      <Typography
                        sx={{
                          fontWeight: "Regular",
                          fontSize: "20px",
                        }}
                      >
                        ดูทั้งหมด
                      </Typography>
                      <ChevronRight
                        sx={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      width: "100%",
                      mb: 2,
                    }}
                  >
                    <Slider {...settings}>
                      {recommendedProducts.map((product, index) => {
                        const { Product } = product;
                        return (
                          <Box
                            key={index}
                            sx={{
                              width: { xs: "100%", sm: 274 }, // กว้างเต็มที่ในหน้าจอเล็ก
                              height: { xs: "auto", sm: 276 }, // ปรับความสูง
                              padding: 1,
                            }}
                          >
                            <Card
                              className={classes.cardProducts}
                              sx={{
                                position: "relative",
                              }}
                            >
                              <CardMedia
                                component="img"
                                image={Product?.Pictures[0]?.pic}
                                alt={Product.product_name}
                                height={190}
                                sx={{
                                  borderRadius: "22px",
                                  objectFit: "cover",
                                  p: "3px",
                                }}
                              />
                              <CardContent
                                sx={{
                                  width: "100%",
                                  padding: 1,
                                  height: "auto",
                                  "&:last-child": { paddingBottom: 1 },
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexDirection: "row",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      width: "70%",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: "prompt",
                                        fontSize: "18px",
                                        fontWeight: "medium",
                                        color: "#212529",
                                      }}
                                      noWrap
                                    >
                                      {Product.product_name}
                                    </Typography>
                                    <PriceFormatter price={Product.price} />
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      border: "2px solid #ccc",
                                      borderRadius: "50%",
                                      height: "45px",
                                      width: "45px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setSelectedProduct(product);
                                      handleModal();
                                    }}
                                  >
                                    <NorthEast
                                      sx={{
                                        width: "20px",
                                        height: "20px",
                                        color: "#00bb9f",
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </CardContent>
                              <Badge
                                sx={{
                                  position: "absolute",
                                  top: 10,
                                  left: 10,
                                }}
                              >
                                <IconButton
                                  sx={{
                                    color: "#D32F2F", // color icon
                                    borderRadius: "50%",
                                    border: "2px solid #fff",
                                  }}
                                >
                                  <Whatshot />
                                </IconButton>
                              </Badge>
                            </Card>
                          </Box>
                        );
                      })}
                    </Slider>
                  </Box>
                </Box>

                {/* Latest Products */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "100%",
                    mt: 2,
                    gap: 2,
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontSize: "32px" }}>
                      สินค้าล่าสุด
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleAllProduct("latest")}
                    >
                      <Typography
                        sx={{
                          fontWeight: "Regular",
                          fontSize: "20px",
                        }}
                      >
                        ดูทั้งหมด
                      </Typography>
                      <ChevronRight
                        sx={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      padding: 1,
                      width: "100%",
                    }}
                  >
                    <Grid container spacing={2}>
                      {lastestProducts.slice(0, 5).map((product, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                          {renderProductCard(product, index)}
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>

                {/* Other Products */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "100%",
                    mt: 2,
                    gap: 2,
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontSize: "32px" }}>อื่นๆ</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleAllProduct("all")}
                    >
                      <Typography
                        sx={{
                          fontWeight: "Regular",
                          fontSize: "20px",
                        }}
                      >
                        ดูทั้งหมด
                      </Typography>
                      <ChevronRight
                        sx={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      padding: 1,
                      width: "100%",
                    }}
                  >
                    <Grid container spacing={2}>
                      {products.map((product, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                          {renderProductCard(product, index)}
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                  <CustomPagination
                    count={paginate.totalItems}
                    page={paginate.page}
                    rowsPerPage={paginate.limit}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                </Box>
              </Box>
            )}
            <Contact />
          </Grid>
        </Grid>
      </Box>

      <ModalProduct
        open={openModal}
        product={selectedProduct}
        closeModal={handleModal}
      />
    </>
  );
}
export default MarketPlace;
